import { ReloadOutlined } from "@ant-design/icons"
import { Button, Tooltip } from "antd"
import type React from "react"
import { memo } from "react"

interface CollocationTableActionsProps {
  onRefresh: () => void
  loading?: boolean
}

const CollocationTableActions: React.FC<CollocationTableActionsProps> = memo(({ onRefresh, loading = false }) => {
  return (
    <div className="flex grow items-center justify-end gap-2">
      <Tooltip title="Tải lại dữ liệu">
        <Button type="default" size="small" icon={<ReloadOutlined />} onClick={onRefresh} loading={loading} />
      </Tooltip>
    </div>
  )
})

CollocationTableActions.displayName = "CollocationTableActions"

export default CollocationTableActions
